import React from 'react';
import {
  IconTicket,
  IconCalendarPlus,
  IconFilePlus,
  IconDoorEnter,
} from '@tabler/icons-react';
import styles from './ToolbarActionGroup.module.css';

interface ToolbarActionGroupProps {
  onNewTicket: () => void;
  onNewAppointment: () => void;
  onNewInvoice: () => void;
  onNewCheckIn: () => void;
}

/**
 * Action buttons for the work-items toolbar: a primary "New ticket" CTA followed by
 * three secondary actions.
 *
 * At 768px and below (ToolbarActionGroup.module.css) New ticket is hidden and the
 * other three become icon-only — four labelled buttons need ~520px on their own. The
 * label is the accessible name and the title there, so it is set on every button.
 */
export const ToolbarActionGroup: React.FC<ToolbarActionGroupProps> = ({
  onNewTicket,
  onNewAppointment,
  onNewInvoice,
  onNewCheckIn,
}) => (
  <div className={styles.group}>
    <button type="button" className={styles.cta} onClick={onNewTicket}>
      <span className={styles.ctaIcon}>
        <IconTicket size={16} stroke={1.5} />
      </span>
      New ticket
    </button>
    <button type="button" className={styles.sec} onClick={onNewAppointment} aria-label="Appointment" title="Appointment">
      <span className={styles.secIcon}>
        <IconCalendarPlus size={16} stroke={1.5} />
      </span>
      <span className={styles.label}>Appointment</span>
    </button>
    <button type="button" className={styles.sec} onClick={onNewInvoice} aria-label="Invoice" title="Invoice">
      <span className={styles.secIcon}>
        <IconFilePlus size={16} stroke={1.5} />
      </span>
      <span className={styles.label}>Invoice</span>
    </button>
    <button type="button" className={styles.sec} onClick={onNewCheckIn} aria-label="Check-in" title="Check-in">
      <span className={styles.secIcon}>
        <IconDoorEnter size={16} stroke={1.5} />
      </span>
      <span className={styles.label}>Check-in</span>
    </button>
  </div>
);
